import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "product-card__prices--internet",
  "data-eq-part": "product-card__prices"
}
const _hoisted_2 = ["innerHTML"]

import Product from '@/classes/Product';
import { formatNumber } from '@/helpers';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardPricesInternet',
  props: {
    product: {}
  },
  setup(__props: any) {

const props = __props;

const followUpPriceString = computed<string | undefined>(() => {
  const savings = props.product.getPriceSavings();

  if (savings.length === 0) return undefined;

  const savingStrings: string[] = [];

  savings.forEach((saving, inx) => {
    let savingPrice: string | number = props.product.getRecurringPriceValue('base_price', true) - saving.value;
    if (savingPrice < 0) savingPrice = 0;
    savingPrice = `${formatNumber(savingPrice, 2)}&thinsp;€&thinsp;/&thinsp;Monat`;

    if (inx === 0) {
      savingStrings.push(`für ${saving.toMonth > 1 ? `${saving.toMonth} Monate` : 'einen Monat'}`);
    } else {
      const savingDuration = (saving.toMonth - (saving.fromMonth - 1)) || 1;
      savingStrings.push(`danach für ${savingDuration > 1 ? `weitere ${savingDuration} Monate` : 'einen weiteren Monat'} ${savingPrice}`);
    }
  });

  savingStrings.push(`danach ${props.product.getRecurringPriceValueFormatted('base_price', 2, true)}&thinsp;€&thinsp;/&thinsp;Monat`);

  return savingStrings.join(', ');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(_ctx.product.getRecurringPriceWithSavingsFormatted('base_price', 2, true)) + " € / Monat ", 1),
    (followUpPriceString.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          innerHTML: followUpPriceString.value
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})